import { useEffect, useState } from 'react';
import { BrandCreatorProfile, getCreatorBrandProfile } from '../api/payment/brand-profile.api';

/** Hồ sơ hợp tác công khai của creator. null khi chưa tải hoặc lỗi: tab "Hợp tác" không hiện. */
export const useCreatorBrandProfile = (userId?: string | null): BrandCreatorProfile | null => {
  const [profile, setProfile] = useState<BrandCreatorProfile | null>(null);

  useEffect(() => {
    setProfile(null);
    if (!userId) return undefined;
    let alive = true;
    getCreatorBrandProfile(userId)
      .then((p) => {
        if (alive) setProfile(p);
      })
      .catch(() => {
        if (alive) setProfile(null);
      });
    return () => {
      alive = false;
    };
  }, [userId]);

  return profile;
};
